module.exports = __webpack_public_path__ + "img/bg.eaef9c4f.jpg";